import { render, staticRenderFns } from "./Wizardot5datadetail.vue?vue&type=template&id=9d5dca24&scoped=true&"
import script from "./Wizardot5datadetail.vue?vue&type=script&lang=js&"
export * from "./Wizardot5datadetail.vue?vue&type=script&lang=js&"
import style0 from "./Wizardot5datadetail.vue?vue&type=style&index=0&id=9d5dca24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5dca24",
  null
  
)

export default component.exports